import { render, staticRenderFns } from "./markerTask.vue?vue&type=template&id=4741a268&scoped=true"
import script from "./markerTask.vue?vue&type=script&lang=js"
export * from "./markerTask.vue?vue&type=script&lang=js"
import style0 from "./markerTask.vue?vue&type=style&index=0&id=4741a268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4741a268",
  null
  
)

export default component.exports